// The weight-stepper magnitudes, in one place.
//
// FocusPanelInputs (strength) and FocusPanelTimed (the added load on a hold)
// each used to declare these, and FocusPanelTimed's comment asked the next
// reader to keep them in sync by hand. A hold's added load must step exactly
// like a normal exercise's weight, so that agreement is now structural.
//
// The values are the plate/dumbbell increments the athlete actually meets:
// 0.5kg is the smallest microplate pair, 1.25/2.5/5 the standard plates. The
// lb column starts one notch up because there is no half-pound plate.
export const STEPS_KG = [0.5, 1.25, 2.5, 5];
export const STEPS_LB = [1.25, 2.5, 5, 10];
